var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDacLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 376.67 76.15",
    role: "img",
    "aria-label": "DAC",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#231815",
    d: "M312.51,21.6l-1.75.14s-28.68,2.42-29.87,21.6c0,0,0,11.62,16.96,11.62l78.83-.37-12.12,21.33h-86.59s-35.51.83-30.56-30.33c0,0,8.15-39.22,78.25-45.05l50.97-.56-11.42,20.72-52.69.88"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#231815",
    d: "M16.08,1.1l84.34.08c37.79,3.29,27.36,34.06,27.36,34.06-19.22,41.93-81.2,40.68-81.2,40.68H0l24.43-43.18h23.26l-13.32,23.05h28.06c31.49-2.85,33.03-19.93,33.03-19.93,1.49-13.65-14.96-13.92-14.96-13.92H3.78L16.08,1.1"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#231815",
    fillRule: "evenodd",
    points: "238.14 1.18 186.56 1.18 90.86 76.07 130.61 72.75 209.39 10.13 216.87 76.15 246.23 75.83 238.14 1.18"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#e60012",
    fillRule: "evenodd",
    points: "130.61 72.71 291.69 .56 184.07 30.27 130.61 72.71"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDacLogo);
export default __webpack_public_path__ + "static/media/dac_logo.0531cab1fca881d0a83ce9b46332942f.svg";
export { ForwardRef as ReactComponent };